import React, { FC, useRef } from "react";
import type {
  ContentfulCardWithImageType,
  PlatformDeploymentOptionsProps,
} from "@/types";
import { ContentManager } from "../content-manager";
import { Cta } from "../cta";
import { useInView } from "@/hooks/reveal-in-view";
import SplitTextAnimation from "../split-text-animation";

export const PlatformDeploymentOptions: FC<PlatformDeploymentOptionsProps> = ({
  title,
  cards,
  cta,
}) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "0px 0px 25% 0px" });

  const [oddCards, setOddCards] = React.useState<ContentfulCardWithImageType[]>(
    []
  );
  const [evenCards, setEvenCards] = React.useState<
    ContentfulCardWithImageType[]
  >([]);

  React.useEffect(() => {
    const odd: ContentfulCardWithImageType[] = [];
    const even: ContentfulCardWithImageType[] = [];

    cards.forEach((card, index) => {
      if (index % 2 === 0) {
        odd.push(card);
      } else {
        even.push(card);
      }
    });

    setOddCards(odd);
    setEvenCards(even);
  }, [cards]);

  return (
    <section className="platformDeploymentOptions">
      <div className="platformDeploymentOptions--inner">
        <div ref={ref} className="wrapper">
          <SplitTextAnimation
            htmlElement={
              <h2 className="platformDeploymentOptions--title">{title}</h2>
            }
            isInView={isInView}
          />
        </div>
        <div className="wrapper wrapper_lg">
          <div className="oymentOptions--content">
            <div className="platformDeploymentOptions--cards">
              {cards.map((card, index) => {
                return (
                  <div
                    key={index}
                    className="platformDeploymentOptions--card platformDeploymentOptions--card_sm"
                    onMouseEnter={(event) => {
                      const target = event.currentTarget as HTMLElement;
                      target.classList.add("hover-animation-bounce");
                    }}
                    onAnimationEnd={(event) => {
                      const target = event.target as HTMLElement;
                      target.classList.remove("hover-animation-bounce");
                    }}
                  >
                    {card.title && (
                      <ContentManager
                        content={card.title}
                        className="platformDeploymentOptions--card-title"
                      />
                    )}
                    {card.description && (
                      <ContentManager
                        content={card.description}
                        className="platformDeploymentOptions--card-description"
                      />
                    )}
                  </div>
                );
              })}
              <div className="platformDeploymentOptions--cards-odd">
                {oddCards.map((card, index) => {
                  return (
                    <div
                      key={index}
                      className="platformDeploymentOptions--card"
                      onMouseEnter={(event) => {
                        const target = event.currentTarget as HTMLElement;
                        target.classList.add("hover-animation-bounce");
                      }}
                      onAnimationEnd={(event) => {
                        const target = event.target as HTMLElement;
                        target.classList.remove("hover-animation-bounce");
                      }}
                    >
                      {card.title && (
                        <ContentManager
                          content={card.title}
                          className="platformDeploymentOptions--card-title"
                        />
                      )}
                      {card.description && (
                        <ContentManager
                          content={card.description}
                          className="platformDeploymentOptions--card-description"
                        />
                      )}
                    </div>
                  );
                })}
              </div>
              <div className="platformDeploymentOptions--cards-even">
                {evenCards.map((card, index) => {
                  return (
                    <div
                      key={index}
                      className="platformDeploymentOptions--card"
                      onMouseEnter={(event) => {
                        const target = event.currentTarget as HTMLElement;
                        target.classList.add("hover-animation-bounce");
                      }}
                      onAnimationEnd={(event) => {
                        const target = event.target as HTMLElement;
                        target.classList.remove("hover-animation-bounce");
                      }}
                    >
                      {card.title && (
                        <ContentManager
                          content={card.title}
                          className="platformDeploymentOptions--card-title"
                        />
                      )}
                      {card.description && (
                        <ContentManager
                          content={card.description}
                          className="platformDeploymentOptions--card-description"
                        />
                      )}
                    </div>
                  );
                })}
              </div>
              {/* TODO: Temporary hidden */}
              {/* <Cta cta={cta} className="platformDeploymentOptions--cta" /> */}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
